import { useMemo } from 'react';
import localFont from 'next/font/local';

import { FormThemeContext } from '../../contexts/FormTheme/FormThemeContext';
import { tspTheme } from '../../contexts/FormTheme/formThemes';
import { useFormController } from '../../hooks/useFormController';
import { createTspFieldFactory } from '../Tsp/tspFieldFactory';
import TspFieldWrapper from '../Tsp/TspFieldWrapper';
import TspLabel from '../Tsp/TspLabel';
import FormBody from './FormBody';
import { FormVariantProps } from './types';

export const GNElliotWeb = localFont({
  src: [
    {
      path: '../../assets/fonts/GNElliotWeb-Light.woff2',
      weight: '300',
      style: 'normal',
    },
    {
      path: '../../assets/fonts/GNElliotWeb-Regular.woff2',
      weight: '400',
      style: 'normal',
    },
    {
      path: '../../assets/fonts/GNElliotWeb-Bold.woff2',
      weight: '600',
      style: 'normal',
    },
    {
      path: '../../assets/fonts/GNElliotWeb-Bold.woff2',
      weight: '700',
      style: 'normal',
    },
    {
      path: '../../assets/fonts/GNElliotWeb-Heavy.woff2',
      weight: '900',
      style: 'normal',
    },
  ],
  variable: '--font-gn-elliot',
});

const TspForm = ({ fields, router, onNextForm }: FormVariantProps) => {
  const controller = useFormController({ fields, router, onNextForm });
  const { formRef, customFormId } = controller;

  const fieldFactory = useMemo(() => createTspFieldFactory(), []);

  return (
    <FormThemeContext.Provider value={tspTheme}>
      <div
        id={customFormId}
        ref={formRef}
        className={`tsp-form-root p-3 pb-8 md:p-4 md:pb-8 ${GNElliotWeb.variable}`}
      >
        <FormBody
          form={fields}
          controller={controller}
          fieldFactory={fieldFactory}
          fieldWrapperComponent={TspFieldWrapper}
          labelComponent={TspLabel}
        />
      </div>
    </FormThemeContext.Provider>
  );
};

export default TspForm;
